import { Component, ViewEncapsulation, ElementRef, OnInit } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import { AuthService } from './services/auth.service';
//import 'hammer.js'


@Component({
  selector: 'sws-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
   host: {
    '[class.unicorn-dark-theme]': 'dark',
  },
  encapsulation: ViewEncapsulation.None, 
})
export class AppComponent implements OnInit{
  
  dark = false;

  navItems = [
    {name: 'Home', route: 'home'},
    {name: 'Artikelliste', route: 'infopage'},
    {name: 'An-/Abmelden', route: 'login'},
    {name: 'Über uns', route: 'about'}
  ];

constructor(private router: Router,
            private location: Location,
            public authService: AuthService,
            private _element: ElementRef) {
 
  }

ngOnInit(): void {
      /* Programm startet in Infohome */
      this.router.navigateByUrl('/home');
  }

toggleFullscreen() {
    let elem = this._element.nativeElement.querySelector('.sws-content');
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullScreen) {
      elem.webkitRequestFullScreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.msRequestFullScreen) {
      elem.msRequestFullScreen();
    }
  }

/* zur Seite Anmeldung */
  login() {
       /* Programm startet in Infohome */
      this.router.navigateByUrl('/login');
   
  }

  /* Abmeldung */
  logout() {
    this.authService.logout();
      this.router.navigateByUrl('/home');
  }
  

}



// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/app.component.ts